import { AsyncPipe, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AppFeatureDims } from '@nk/data-entities-lib';
import { Observable } from 'rxjs';
import { AppFeatureService } from '../../services/app-feature.service';
import { AppSubscriptionState, AppSubscriptionStateDetails } from '../../utils/subscription.utils';

@Component({
  selector: 'nk-customer-trial-or-cancelled-contact-sales',
  standalone: true,
  imports: [AsyncPipe, DatePipe, TranslateModule],
  templateUrl: './customer-trial-or-cancelled-contact-sales.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerTrialOrCancelledContactSalesComponent implements OnInit {
  public activeFeatures = input<AppFeatureDims | undefined>(undefined);
  public subscriptionData$: Observable<AppSubscriptionStateDetails>;
  public appSubscriptionState = AppSubscriptionState;

  constructor(private _appFeatureService: AppFeatureService) {}

  public ngOnInit(): void {
    this.subscriptionData$ = this._appFeatureService.appSubscriptionState();
  }
}
